import React from 'react';
import { I18n } from 'react-redux-i18n';
import { get } from 'lodash';

import { TemplatePage } from '../../../components/common/pager';
import { TemplateHeader } from '../../../components/template/templateHeader';
import { TagsInput } from '../../../components/tagInput';
import { TemplateDropdown } from '../../../components/template/templateDropdown';
import { TemplateInput } from '../../../components/template/templateInput';
import { TemplateHorizontalRule } from '../../../components/template/templateHorizontalRule';
import { TemplateLazyAutocomplete } from '../../../components/template/templateLazyAutocomplete';
import { TemplateToggle } from '../../../components/template/templateToggle';
import { getEntityOption } from '../../../helpers/entityOptionHelper';

import { paths } from '../constants/template';
import CustomSettings from './eyesOnly/custom-settings';
import { TemplateCheckbox } from '../../../components/template/templateCheckbox';

export const getEyesOnlyTab = (props) => {
  return (
    <TemplatePage id="eyes-only" i18nKey="template.page.eyes-only" systemOnly>
      <TemplateHeader
        as="h3"
        label="event.template.page.eyes-only.tags.header"
      />

      <TagsInput path={paths.TAGS} onChange={props.onChange} />

      <TemplateHorizontalRule />

      <TemplateHeader
        as="h3"
        label="event.template.page.eyes-only.general-settings.header"
      />

      <TemplateDropdown
        path={paths.RAISED_TOTAL_TYPE}
        label="event.template.page.eyes-only.general-settings.raisedTotalType.label"
        onChange={props.onChange}
        options={props.raisedTotalTypeOptions}
      />

      <TemplateCheckbox
        path={paths.DISPLAY_FULL_AMOUNT_PRECISION}
        inputLabel="event.template.page.eyes-only.general-settings.displayFullAmountPrecision.label"
        onChange={props.onChange}
      />

      <TemplateHorizontalRule path="template.value.forceRedirectTo" />

      <TemplateHeader
        as="h3"
        path="template.value.forceRedirectTo"
        label="template.fundraiser.content.eyes-only.forceRedirect.header"
      />

      <TemplateInput
        id="template.value.forceRedirectTo"
        path="template.value.forceRedirectTo"
        label="template.fundraiser.content.eyes-only.forceRedirect.label"
        subtext="template.fundraiser.content.eyes-only.forceRedirect.subtext"
        subtextPosition="bottom"
        validation={{
          url: true
        }}
        onChange={props.onChange}
      />

      <TemplateHorizontalRule />

      <TemplateHeader
        as="h3"
        label="event.template.page.eyes-only.linked-entities.header"
      />

      <TemplateLazyAutocomplete
        id="franchise"
        entity="Franchise"
        path={paths.FRANCHISE_ID}
        selectedKey="franchise"
        objectPath="franchise"
        label="event.template.page.eyes-only.franchise.label"
        placeholder="event.template.page.eyes-only.franchise.placeholder"
        onChange={(p, v, selected) => {
          // clear edition when franchise changes or is cleared
          props.onChange(paths.FRANCHISE_EDITION_ID, null);
          // store selected object for preview and dependent dropdown; clear if none
          props.onChange('franchise', selected || null);
          props.onChange(p, v);
        }}
        request={props.getFranchiseRequest}
        getItem={(item) => (item ? getEntityOption(item) : undefined)}
        returnField="id"
      />

      <TemplateToggle
        path={paths.FRANCHISE_ID}
      >
        <TemplateDropdown
          id="franchiseEdition"
          path={paths.FRANCHISE_EDITION_ID}
          label="event.template.page.eyes-only.franchise-edition.label"
          placeholder="event.template.page.eyes-only.franchise-edition.placeholder"
          onChange={props.onChange}
          options={[
            { text: I18n.t('common.notSelected'), value: null },
            ...((get(props.templateBuilder, 'franchise.editions', []) || [])
              .filter((e) => !e.isDeleted)
              .map((e) => ({ text: `${e.name} (${e.id})`, value: e.id })))
          ]}
          disabled={!!props.hasEventId}
        />

        <TemplateInput
          id={paths.FRANCHISE_EDITION_LOCATION_CITY}
          path={paths.FRANCHISE_EDITION_LOCATION_CITY}
          label="event.template.page.eyes-only.franchise-edition-location-city.label"
          subtext="event.template.page.eyes-only.franchise-edition-location-city.subtext"
          subtextPosition="bottom"
          onChange={props.onChange}
          disabled={!!props.hasEventId}
        />

        <TemplateInput
          id={paths.FRANCHISE_EDITION_LOCATION_STATE}
          path={paths.FRANCHISE_EDITION_LOCATION_STATE}
          label="event.template.page.eyes-only.franchise-edition-location-state.label"
          subtext="event.template.page.eyes-only.franchise-edition-location-state.subtext"
          subtextPosition="bottom"
          onChange={props.onChange}
          disabled={!!props.hasEventId}
        />

        <TemplateInput
          id={paths.FRANCHISE_EDITION_ACTIVITY_TYPE}
          path={paths.FRANCHISE_EDITION_ACTIVITY_TYPE}
          label="event.template.page.eyes-only.franchise-edition-activity-type.label"
          subtext="event.template.page.eyes-only.franchise-edition-activity-type.subtext"
          subtextPosition="bottom"
          onChange={props.onChange}
          disabled={!!props.hasEventId}
        />

        <TemplateInput
          id={paths.FRANCHISE_EDITION_YEAR}
          path={paths.FRANCHISE_EDITION_YEAR}
          label="event.template.page.eyes-only.franchise-edition-year.label"
          subtext="event.template.page.eyes-only.franchise-edition-year.subtext"
          subtextPosition="bottom"
          onChange={props.onChange}
          disabled={!!props.hasEventId}
        />
      </TemplateToggle>

      <CustomSettings />
    </TemplatePage>
  );
};
